const TESTDATA_HISTORY = [
    {
        "date": "27.03.2023",
        "result": -2425.0699999999997,
        "orders": [
            {
                "type": 2,
                "date_update": "27.03.2023 10:02",
                "name": "SMLT",
                "amount": 10,
                "result": "-389.57",
                "currency": "rub",
                "comment": "Казалось что на открытии пойдёт вниз, а он начал отрастать вовсю"
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:05",
                "name": "LSNG",
                "amount": 6,
                "result": "-71.76",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:10",
                "name": "SMLT",
                "amount": 9,
                "result": "-62.72",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:13",
                "name": "KAZT",
                "amount": 2,
                "result": "-234.01",
                "currency": "rub",
                "comment": "Поздно зашёл на новости о дивидиендах. Почти сразу же развернулась и пришлось резать лося..."
            },
            {
                "type": 2,
                "date_update": "27.03.2023 10:17",
                "name": "MVID",
                "amount": 125,
                "result": "93.49",
                "currency": "rub",
                "comment": "Хорошо шортанул на разъедание бида"
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:18",
                "name": "GLTR",
                "amount": 51,
                "result": "-140.23",
                "currency": "rub",
                "comment": "Казалось на открытии пойдёт вверх, новость +65% чистой прибыли, а она канула вниз"
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:24",
                "name": "MVID",
                "amount": 123,
                "result": "-313.92",
                "currency": "rub",
                "comment": "Разъело проклятую заявку аска и потом цена потопталась и развернулась вниз. Продал на пробитии поддержки"
            },
            {
                "type": 2,
                "date_update": "27.03.2023 10:29",
                "name": "SMLT",
                "amount": 10,
                "result": "40.21",
                "currency": "rub",
                "comment": "Акция немного росла, потом гэпнула до моей цены откупа"
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:38",
                "name": "AFLT",
                "amount": 76,
                "result": "-178.95",
                "currency": "rub",
                "comment": "Набиьтый бид, пустой аск, новость что авиакомпании увеличат количество рейсов. Зашёл - акция вниз. Мда.."
            },
            {
                "type": 2,
                "date_update": "27.03.2023 10:47",
                "name": "SMLT",
                "amount": 10,
                "result": "-164.82",
                "currency": "rub",
                "comment": "Падала падала, взял в шорт. Потопталась и гэп вверх. Отличненько блять.."
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:55",
                "name": "KMAZ",
                "amount": 20,
                "result": "120.68",
                "currency": "rub",
                "comment": "Зашёл в рост, рано вышел, она еще в 2 раза сильнее выросла. Но лучше уж рано выйти чем поздно..."
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:56",
                "name": "GLTR",
                "amount": 51,
                "result": "-157.67",
                "currency": "rub",
                "comment": "Подобрал в самом низу, когда начала немного отростать. В итоге ещё ниже пошла..."
            },
            {
                "type": 1,
                "date_update": "27.03.2023 10:58",
                "name": "BSPB",
                "amount": 16,
                "result": "-965.80",
                "currency": "rub",
                "comment": "Плохая была идея брать по сигналу"
            }
        ]
    },
    {
        "date": "24.03.2023",
        "result": -536.7700000000001,
        "orders": [
            {
                "type": 2,
                "date_update": "24.03.2023 10:22",
                "name": "POLY",
                "amount": 27,
                "result": "-35.94",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "24.03.2023 10:24",
                "name": "BSPB",
                "amount": 15,
                "result": "168.37",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "24.03.2023 10:26",
                "name": "MOEX",
                "amount": 22,
                "result": "87.96",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "24.03.2023 10:35",
                "name": "MOEX",
                "amount": 22,
                "result": "-68.28",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 2,
                "date_update": "24.03.2023 10:39",
                "name": "POLY",
                "amount": 27,
                "result": "-65.96",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "24.03.2023 10:53",
                "name": "POLY",
                "amount": 31,
                "result": "54.42",
                "currency": "rub",
                "comment": "Не стал скидывать в минус, т.к. акция не пробила поддержку. Затем она резко стрельнула вверх до моей лимитки"
            },
            {
                "type": 1,
                "date_update": "24.03.2023 11:26",
                "name": "AFLT",
                "amount": 87,
                "result": "40.39",
                "currency": "rub",
                "comment": "Новость +6% пассажиров в феврале. Сначала взял и чуть вниз пошла, потом подержал и идеально вышел - после продажи она пошла вниз."
            },
            {
                "type": 1,
                "date_update": "24.03.2023 11:54",
                "name": "BELU",
                "amount": 6,
                "result": "-150.78",
                "currency": "rub",
                "comment": "Зашёл на отчёте прибыль +10% и акция медленно но верно пошла вниз. Подождал немного и зарезал"
            },
            {
                "type": 2,
                "date_update": "24.03.2023 11:59",
                "name": "POLY",
                "amount": 26,
                "result": "9.25",
                "currency": "rub",
                "comment": "Дождался пока цена дойдёт до сопротивления, и зашёл в шорт. Выставил заявку у поддержки, но цена гэпом пробила её"
            },
            {
                "type": 1,
                "date_update": "24.03.2023 12:01",
                "name": "RNFT",
                "amount": 193,
                "result": "-576.20",
                "currency": "rub",
                "comment": "Была волатильность, много бида, мало аска. Зашёл, мог выйти раньше в плюс, но пожадничал. Волатильность закончилась, акция стала медленно идти вниз. Жду жду, смотрю - всё ниже и ниже, в итоге зарезал пока она не обвалилась ещё глубже..."
            }
        ]
    },
    {
        "date": "23.03.2023",
        "result": 30.690000000000012,
        "orders": [
            {
                "type": 1,
                "date_update": "23.03.2023 10:04",
                "name": "NVTK",
                "amount": 22,
                "result": "32.92",
                "currency": "rub",
                "comment": "На разъедание аска зашел"
            },
            {
                "type": 1,
                "date_update": "23.03.2023 10:08",
                "name": "POLY",
                "amount": 31,
                "result": "44.88",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 2,
                "date_update": "23.03.2023 10:10",
                "name": "POLY",
                "amount": 31,
                "result": "-41.27",
                "currency": "rub",
                "comment": "Думал ща обвалится, зашёл в шорт на хаях при растущем индексе"
            },
            {
                "type": 1,
                "date_update": "23.03.2023 10:12",
                "name": "NVTK",
                "amount": 22,
                "result": "-15.52",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "23.03.2023 10:31",
                "name": "GAZP",
                "amount": 10,
                "result": "7.75",
                "currency": "rub",
                "comment": "Было опасно, вышел пораньше"
            },
            {
                "type": 1,
                "date_update": "23.03.2023 10:29",
                "name": "POLY",
                "amount": 31,
                "result": "43.49",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "23.03.2023 10:54",
                "name": "MSRS",
                "amount": 5,
                "result": "-41.56",
                "currency": "rub",
                "comment": "Не смотря хороший отчёт, цена пошла вниз. Сначала стакан дёргался, думал закрыть в хороший плюс, потом в менее хороший, в итоге скинул в минус пока не поздно"
            }
        ]
    },
    {
        "date": "22.03.2023",
        "result": -274.46000000000004,
        "orders": [
            {
                "type": 1,
                "date_update": "22.03.2023 10:04",
                "name": "POLY",
                "amount": 32,
                "result": "-42.64",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:06",
                "name": "GAZP",
                "amount": 11,
                "result": "1.03",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 2,
                "date_update": "22.03.2023 10:15",
                "name": "POLY",
                "amount": 54,
                "result": "-73.79",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:10",
                "name": "GAZP",
                "amount": 11,
                "result": "1.91",
                "currency": "rub",
                "comment": "Успел скинуть"
            },
            {
                "type": 2,
                "date_update": "22.03.2023 10:18",
                "name": "POLY",
                "amount": 52,
                "result": "-3.42",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:21",
                "name": "LNZLP",
                "amount": 2,
                "result": "94.38",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:22",
                "name": "POLY",
                "amount": 52,
                "result": "17.59",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:22",
                "name": "MRKY",
                "amount": 10,
                "result": "-58.42",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:25",
                "name": "LNZLP",
                "amount": 2,
                "result": "-115.62",
                "currency": "rub",
                "comment": "Исчезли заявки на покупку и полетело"
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:31",
                "name": "LNZLP",
                "amount": 2,
                "result": "-75.55",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 2,
                "date_update": "22.03.2023 10:32",
                "name": "GAZP",
                "amount": 13,
                "result": "-0.09",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:35",
                "name": "MSTT",
                "amount": 4,
                "result": "2.56",
                "currency": "rub",
                "comment": "Рано вышел"
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:37",
                "name": "MSTT",
                "amount": 4,
                "result": "-8.85",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:40",
                "name": "MSTT",
                "amount": 4,
                "result": "11.94",
                "currency": "rub",
                "comment": "На бешенной волатильности лучше сразу продать"
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:42",
                "name": "MSTT",
                "amount": 4,
                "result": "-10.07",
                "currency": "rub",
                "comment": ""
            },
            {
                "type": 1,
                "date_update": "22.03.2023 10:46",
                "name": "LNZLP",
                "amount": 2,
                "result": "-15.42",
                "currency": "rub",
                "comment": ""
            }
        ]
    },
    {
        "date": "20.03.2023",
        "result": -103.47000000000003,
        "orders": [
            {
                "type": 1,
                "date_update": "20.03.2023 10:00",
                "name": "PLZL",
                "result": "47.79",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:01",
                "name": "POLY",
                "result": "94.19",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.03.2023 10:09",
                "name": "TATN",
                "result": "-44.23",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:12",
                "name": "GAZP",
                "result": "4.41",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:18",
                "name": "POLY",
                "result": "-59.30",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:22",
                "name": "TATN",
                "result": "72.84",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:24",
                "name": "GAZP",
                "result": "50.02",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:25",
                "name": "POLY",
                "result": "63.05",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.03.2023 10:28",
                "name": "POLY",
                "result": "-45.77",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:34",
                "name": "GAZP",
                "result": "4.34",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:53",
                "name": "GAZP",
                "result": "-63.20",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 10:58",
                "name": "PLZL",
                "result": "-112.32",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 11:00",
                "name": "CNTL",
                "result": "-21.64",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 15:31",
                "name": "GAZP",
                "result": "-27.23",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.03.2023 15:53",
                "name": "GAZP",
                "result": "45.17",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 16:02",
                "name": "GAZP",
                "result": "-1.91",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.03.2023 16:07",
                "name": "GAZP",
                "result": "-58.45",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.03.2023 16:14",
                "name": "GAZP",
                "result": "-15.14",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.03.2023 16:21",
                "name": "GAZP",
                "result": "-36.09",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "17.03.2023",
        "result": -811.59,
        "orders": [
            {
                "type": 2,
                "date_update": "17.03.2023 10:05",
                "name": "RUAL",
                "result": "5.85",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 10:06",
                "name": "SBER",
                "result": "-9.38",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 10:12",
                "name": "RUAL",
                "result": "-73.76",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:20",
                "name": "RUAL",
                "result": "-92.08",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:19",
                "name": "RUAL",
                "result": "8.69",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 10:24",
                "name": "RUAL",
                "result": "-98.22",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:24",
                "name": "POLY",
                "result": "-87.93",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:31",
                "name": "RUAL",
                "result": "41.62",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:31",
                "name": "RUAL",
                "result": "-64.04",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:39",
                "name": "PLZL",
                "result": "-26.79",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:41",
                "name": "CNTL",
                "result": "24.88",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:44",
                "name": "RUAL",
                "result": "14.72",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 10:59",
                "name": "RUAL",
                "result": "10.25",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 11:02",
                "name": "PLZL",
                "result": "4.20",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 11:07",
                "name": "CNTL",
                "result": "-137.07",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 17:23",
                "name": "TATN",
                "result": "-324.26",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 17:26",
                "name": "RUAL",
                "result": "-11.41",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 17:36",
                "name": "TATN",
                "result": "25.48",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.03.2023 17:41",
                "name": "GAZP",
                "result": "16.40",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.03.2023 17:46",
                "name": "RUAL",
                "result": "-38.74",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "16.03.2023",
        "result": -1220.24,
        "orders": [
            {
                "type": 1,
                "date_update": "16.03.2023 10:14",
                "name": "POLY",
                "result": "-286.61",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.03.2023 10:20",
                "name": "CNTL",
                "result": "60.87",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.03.2023 10:21",
                "name": "POLY",
                "result": "-126.92",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.03.2023 10:22",
                "name": "VKCO",
                "result": "-83.11",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.03.2023 10:25",
                "name": "POLY",
                "result": "-132.24",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.03.2023 10:38",
                "name": "VKCO",
                "result": "-127.89",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.03.2023 10:38",
                "name": "RASP",
                "result": "-524.34",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "15.03.2023",
        "result": -2671.98,
        "orders": [
            {
                "type": 1,
                "date_update": "15.03.2023 10:10",
                "name": "POLY",
                "result": "-66.16",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 10:10",
                "name": "POLY",
                "result": "-36.83",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.03.2023 10:12",
                "name": "POLY",
                "result": "-33.05",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.03.2023 10:18",
                "name": "SELG",
                "result": "-123.81",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.03.2023 10:29",
                "name": "CNTL",
                "result": "24.77",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 10:36",
                "name": "POLY",
                "result": "-69.48",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 11:26",
                "name": "PLZL",
                "result": "347.93",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 13:12",
                "name": "PLZL",
                "result": "-1644.75",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 13:12",
                "name": "POLY",
                "result": "-175.77",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.03.2023 17:54",
                "name": "PLZL",
                "result": "134.37",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 17:54",
                "name": "PLZL",
                "result": "139.41",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.03.2023 17:56",
                "name": "PLZL",
                "result": "-220.03",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.03.2023 17:57",
                "name": "PLZL",
                "result": "-948.58",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "14.03.2023",
        "result": 21.279999999999994,
        "orders": [
            {
                "type": 1,
                "date_update": "14.03.2023 12:03",
                "name": "VK",
                "result": "-56.36",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "14.03.2023 12:05",
                "name": "POLY",
                "result": "82.96",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.03.2023 12:06",
                "name": "POLY",
                "result": "-5.32",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "13.03.2023",
        "result": -881.4699999999999,
        "orders": [
            {
                "type": 1,
                "date_update": "13.03.2023 10:03",
                "name": "CNTL",
                "result": "170.35",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:09",
                "name": "CNTL",
                "result": "-385.59",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:17",
                "name": "PLZL",
                "result": "59.03",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:23",
                "name": "PLZL",
                "result": "3.51",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:28",
                "name": "RUAL",
                "result": "-92.07",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:34",
                "name": "MAGN",
                "result": "-35.40",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.03.2023 10:40",
                "name": "MAGN",
                "result": "-5.38",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 10:42",
                "name": "RUAL",
                "result": "-83.07",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 11:16",
                "name": "GAZP",
                "result": "-0.80",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 14:04",
                "name": "CNTL",
                "result": "-630.08",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 15:16",
                "name": "MAGN",
                "result": "-25.98",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.03.2023 15:12",
                "name": "MAGN",
                "result": "75.59",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 15:16",
                "name": "SELG",
                "result": "74.48",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 15:21",
                "name": "POLY",
                "result": "43.89",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.03.2023 18:49",
                "name": "SELG",
                "result": "-0.78",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.03.2023 19:13",
                "name": "POLY",
                "result": "-49.17",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "10.03.2023",
        "result": -539.0500000000002,
        "orders": [
            {
                "type": 1,
                "date_update": "10.03.2023 10:04",
                "name": "CNTL",
                "result": "280.32",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:06",
                "name": "CNTL",
                "result": "327.21",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:11",
                "name": "CNTL",
                "result": "295.85",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:20",
                "name": "CNTL",
                "result": "-458.13",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:26",
                "name": "CNTL",
                "result": "14.38",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:35",
                "name": "POLY",
                "result": "0.96",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:51",
                "name": "CNTL",
                "result": "-1067.93",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:54",
                "name": "CNTL",
                "result": "47.43",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 10:55",
                "name": "CNTL",
                "result": "-72.62",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 11:00",
                "name": "CNTL",
                "result": "107.29",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "10.03.2023 11:01",
                "name": "MAGN",
                "result": "4.09",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 11:10",
                "name": "CNTL",
                "result": "-56.69",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 11:14",
                "name": "CNTL",
                "result": "74.70",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.03.2023 11:25",
                "name": "CNTL",
                "result": "-35.91",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "09.03.2023",
        "result": -611.61,
        "orders": [
            {
                "type": 1,
                "date_update": "09.03.2023 10:22",
                "name": "SBER",
                "result": "-46.95",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 10:37",
                "name": "SBER",
                "result": "-4.78",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 10:55",
                "name": "CNTL",
                "result": "99.75",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 11:02",
                "name": "CHMF",
                "result": "-36.91",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 11:26",
                "name": "SBER",
                "result": "-359.77",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "09.03.2023 11:27",
                "name": "SBER",
                "result": "-131.67",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 11:52",
                "name": "SBER",
                "result": "13.80",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 12:02",
                "name": "CNTL",
                "result": "67.68",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 12:13",
                "name": "SBER",
                "result": "-130.27",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 12:17",
                "name": "POLY",
                "result": "-90.14",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.03.2023 12:50",
                "name": "CNTL",
                "result": "7.65",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "07.03.2023",
        "result": -701.9900000000001,
        "orders": [
            {
                "type": 1,
                "date_update": "07.03.2023 11:25",
                "name": "SBER",
                "result": "-1.72",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "07.03.2023 13:29",
                "name": "SBER",
                "result": "-5.64",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "07.03.2023 13:30",
                "name": "YNDX",
                "result": "-55.34",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "07.03.2023 13:39",
                "name": "AGRO",
                "result": "-554.58",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "07.03.2023 13:53",
                "name": "SBER",
                "result": "-2.84",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "07.03.2023 18:11",
                "name": "POLY",
                "result": "-33.55",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "07.03.2023 18:12",
                "name": "PLZL",
                "result": "-48.32",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "06.03.2023",
        "result": 7.5600000000000005,
        "orders": [
            {
                "type": 1,
                "date_update": "06.03.2023 10:07",
                "name": "PLZL",
                "result": "9.48",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "06.03.2023 10:07",
                "name": "PLZL",
                "result": "10.91",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "06.03.2023 10:08",
                "name": "PLZL",
                "result": "2.95",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "06.03.2023 10:13",
                "name": "PLZL",
                "result": "-12.05",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "06.03.2023 10:15",
                "name": "POLY",
                "result": "10.89",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "06.03.2023 10:18",
                "name": "POLY",
                "result": "-13.10",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "06.03.2023 10:29",
                "name": "SBER",
                "result": "-1.52",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "02.03.2023",
        "result": -1827.1,
        "orders": [
            {
                "type": 1,
                "date_update": "02.03.2023 10:44",
                "name": "SBER",
                "result": "10.42",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "02.03.2023 10:50",
                "name": "POLY",
                "result": "1.57",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "02.03.2023 10:56",
                "name": "SBER",
                "result": "0.60",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "02.03.2023 11:26",
                "name": "POLY",
                "result": "-1.62",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "02.03.2023 12:09",
                "name": "POLY",
                "result": "0.18",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "02.03.2023 12:50",
                "name": "POLY",
                "result": "2.80",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "02.03.2023 13:16",
                "name": "SBER",
                "result": "-1019.98",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "02.03.2023 13:20",
                "name": "SBER",
                "result": "318.92",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "02.03.2023 13:23",
                "name": "SBER",
                "result": "208.74",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "02.03.2023 13:36",
                "name": "SBER",
                "result": "-976.52",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "02.03.2023 13:38",
                "name": "POLY",
                "result": "-372.21",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "01.03.2023",
        "result": -518.21,
        "orders": [
            {
                "type": 1,
                "date_update": "01.03.2023 12:05",
                "name": "SBER",
                "result": "90.58",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:04",
                "name": "POLY",
                "result": "-12.54",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "01.03.2023 12:16",
                "name": "POLY",
                "result": "-418.67",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:16",
                "name": "POLY",
                "result": "-128.82",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:07",
                "name": "SBER",
                "result": "8.80",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "01.03.2023 12:08",
                "name": "SBER",
                "result": "11.21",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:08",
                "name": "SBER",
                "result": "-0.01",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:09",
                "name": "SBER",
                "result": "0.04",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "01.03.2023 12:10",
                "name": "SBER",
                "result": "-15.68",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "01.03.2023 12:10",
                "name": "SBER",
                "result": "-48.10",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "01.03.2023 12:11",
                "name": "SBER",
                "result": "-5.02",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "28.02.2023",
        "result": -873.6200000000001,
        "orders": [
            {
                "type": 1,
                "date_update": "28.02.2023 11:37",
                "name": "POLY",
                "result": "-7.48",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:38",
                "name": "SBER",
                "result": "-13.67",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "28.02.2023 11:42",
                "name": "SBER",
                "result": "-54.95",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "28.02.2023 11:46",
                "name": "SBER",
                "result": "43.57",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:50",
                "name": "SBER",
                "result": "-98.57",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:48",
                "name": "POLY",
                "result": "3.42",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:50",
                "name": "ИСКЧ",
                "result": "-86.85",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:53",
                "name": "SBER",
                "result": "49.98",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:53",
                "name": "SBER",
                "result": "-38.03",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:55",
                "name": "SBER",
                "result": "-330.21",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "28.02.2023 11:57",
                "name": "SBER",
                "result": "-601.65",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "28.02.2023 11:59",
                "name": "SBER",
                "result": "260.82",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "27.02.2023",
        "result": -662.4300000000001,
        "orders": [
            {
                "type": 2,
                "date_update": "27.02.2023 12:04",
                "name": "MTC",
                "result": "135.20",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "27.02.2023 12:05",
                "name": "RASP",
                "result": "-190.37",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "27.02.2023 12:13",
                "name": "MTC",
                "result": "-231.85",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "27.02.2023 12:15",
                "name": "SBER",
                "result": "-29.04",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "27.02.2023 12:15",
                "name": "SBER",
                "result": "-18.37",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "27.02.2023 12:16",
                "name": "POLY",
                "result": "-4.96",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "27.02.2023 12:17",
                "name": "SBER",
                "result": "27.92",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "27.02.2023 12:19",
                "name": "SBER",
                "result": "-105.42",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "27.02.2023 12:19",
                "name": "SBER",
                "result": "-37.70",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "22.02.2023",
        "result": 300.33,
        "orders": [
            {
                "type": 2,
                "date_update": "22.02.2023 10:04",
                "name": "POLY",
                "result": "10.06",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "22.02.2023 10:13",
                "name": "PLZL",
                "result": "-20.93",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "22.02.2023 10:15",
                "name": "POLY",
                "result": "12.08",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "22.02.2023 10:39",
                "name": "POLY",
                "result": "18.73",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "22.02.2023 11:01",
                "name": "POLY",
                "result": "31.88",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "22.02.2023 11:42",
                "name": "POLY",
                "result": "141.98",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "22.02.2023 15:33",
                "name": "SBER",
                "result": "106.53",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "21.02.2023",
        "result": 389.39,
        "orders": [
            {
                "type": 2,
                "date_update": "21.02.2023 10:12",
                "name": "POLY",
                "result": "-7.34",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "21.02.2023 10:20",
                "name": "POLY",
                "result": "13.55",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "21.02.2023 11:26",
                "name": "SBERP",
                "result": "146.46",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "21.02.2023 11:43",
                "name": "CHMF",
                "result": "156.12",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "21.02.2023 11:47",
                "name": "POLY",
                "result": "80.60",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "20.02.2023",
        "result": -966.4,
        "orders": [
            {
                "type": 2,
                "date_update": "20.02.2023 10:19",
                "name": "POLY",
                "result": "1.48",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 10:27",
                "name": "POLY",
                "result": "14.01",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 10:48",
                "name": "SBERP",
                "result": "4.68",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.02.2023 10:57",
                "name": "POLY",
                "result": "0.88",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 11:11",
                "name": "POLY",
                "result": "-10.45",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 11:12",
                "name": "SBERP",
                "result": "-1.08",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 11:13",
                "name": "SBER",
                "result": "-390.64",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 11:48",
                "name": "PZLZ",
                "result": "25.91",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 11:56",
                "name": "PZLZ",
                "result": "-2.96",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.02.2023 12:02",
                "name": "PZLZ",
                "result": "-178.07",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.02.2023 12:07",
                "name": "PLZL",
                "result": "-124.05",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 12:09",
                "name": "POLY",
                "result": "63.77",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 12:11",
                "name": "PLZL",
                "result": "1.40",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "20.02.2023 12:19",
                "name": "PLZL",
                "result": "-43.04",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 12:59",
                "name": "PLZL",
                "result": "-200.11",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 13:13",
                "name": "YNDX",
                "result": "-6.66",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "20.02.2023 13:16",
                "name": "SBER",
                "result": "-121.47",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "17.02.2023",
        "result": 63.57,
        "orders": [
            {
                "type": 1,
                "date_update": "17.02.2023 10:26",
                "name": "SBER",
                "result": "10.71",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "17.02.2023 11:00",
                "name": "POLY",
                "result": "21.15",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.02.2023 11:04",
                "name": "POLY",
                "result": "13.34",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.02.2023 11:07",
                "name": "SBER",
                "result": "5.05",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "17.02.2023 11:13",
                "name": "POLY",
                "result": "13.32",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "16.02.2023",
        "result": 77.78,
        "orders": [
            {
                "type": 2,
                "date_update": "16.02.2023 10:13",
                "name": "GAZP",
                "result": "5.92",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.02.2023 10:16",
                "name": "GAZP",
                "result": "4.70",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.02.2023 10:16",
                "name": "SBER",
                "result": "4.70",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 10:22",
                "name": "POLY",
                "result": "14.32",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 10:30",
                "name": "POLY",
                "result": "3.46",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "16.02.2023 10:40",
                "name": "YNDX",
                "result": "20.81",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 10:41",
                "name": "YNDX",
                "result": "-6.80",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 10:49",
                "name": "YNDX",
                "result": "4.42",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 11:03",
                "name": "YNDX",
                "result": "6.82",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "16.02.2023 11:54",
                "name": "POLY",
                "result": "19.43",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "15.02.2023",
        "result": -421.95000000000005,
        "orders": [
            {
                "type": 2,
                "date_update": "15.02.2023 10:02",
                "name": "POLY",
                "result": "7.11",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.02.2023 10:02",
                "name": "SBER",
                "result": "-160.84",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.02.2023 10:02",
                "name": "SBER",
                "result": "48.05",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "15.02.2023 10:07",
                "name": "PLZL",
                "result": "-145.63",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.02.2023 10:07",
                "name": "PLZL",
                "result": "-64.17",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "15.02.2023 10:07",
                "name": "PLZL",
                "result": "-106.47",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "14.02.2023",
        "result": -252.29000000000002,
        "orders": [
            {
                "type": 2,
                "date_update": "14.02.2023 10:02",
                "name": "MAGN",
                "result": "-2.80",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.02.2023 10:06",
                "name": "PLZL",
                "result": "-23.21",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.02.2023 10:08",
                "name": "PLZL",
                "result": "-29.19",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "14.02.2023 10:09",
                "name": "MAGN",
                "result": "0.54",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "14.02.2023 10:11",
                "name": "BELU",
                "result": -97,
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "14.02.2023 10:32",
                "name": "KLSB",
                "result": "-38.62",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.02.2023 10:33",
                "name": "VKCO",
                "result": "2.03",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.02.2023 10:36",
                "name": "SBER",
                "result": "-3.83",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "14.02.2023 10:47",
                "name": "POLY",
                "result": "-60.21",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "13.02.2023",
        "result": -252.85000000000002,
        "orders": [
            {
                "type": 1,
                "date_update": "13.02.2023 10:01",
                "name": "KMAZ",
                "result": "-36.16",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.02.2023 10:06",
                "name": "MAGN",
                "result": "0.22",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.02.2023 10:12",
                "name": "MAGN",
                "result": 71,
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.02.2023 10:15",
                "name": "MAGN",
                "result": "-27.79",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.02.2023 10:25",
                "name": "MAGN",
                "result": "-2.77",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.02.2023 10:29",
                "name": "PLZL",
                "result": "-21.84",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.02.2023 10:22",
                "name": "KMAZ",
                "result": "25.87",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.02.2023 11:09",
                "name": "MAGN",
                "result": "0.80",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "13.02.2023 11:18",
                "name": "MAGN",
                "result": "-0.48",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.02.2023 10:09",
                "name": "SMLT",
                "result": "-157.41",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "13.02.2023 10:08",
                "name": "SBER",
                "result": "-104.29",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "10.02.2023",
        "result": -103.06000000000002,
        "orders": [
            {
                "type": 2,
                "date_update": "10.02.2023 10:09",
                "name": "SBER",
                "result": "0.72",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "10.02.2023 10:20",
                "name": "SBER",
                "result": "-1.28",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 10:58",
                "name": "SBER",
                "result": "0.52",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 10:59",
                "name": "MGTSP",
                "result": "36.94",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 11:04",
                "name": "SBER",
                "result": "-2.50",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "10.02.2023 11:11",
                "name": "SBER",
                "result": "7.12",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 11:12",
                "name": "MGTSP",
                "result": "-108.95",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 11:38",
                "name": "KMAZ",
                "result": "18.83",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "10.02.2023 11:58",
                "name": "POLY",
                "result": "-55.26",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "10.02.2023 12:09",
                "name": "SBER",
                "result": "0.80",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "09.02.2023",
        "result": 3.6399999999999997,
        "orders": [
            {
                "type": 1,
                "date_update": "09.02.2023 12:30",
                "name": "SBER",
                "result": "2.57",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "09.02.2023 12:31",
                "name": "SBER",
                "result": "-4.64",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "09.02.2023 12:44",
                "name": "SBER",
                "result": "-3.06",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "09.02.2023 12:50",
                "name": "SBER",
                "result": "8.77",
                "currency": "rub"
            }
        ]
    },
    {
        "date": "08.02.2023",
        "result": -35.54,
        "orders": [
            {
                "type": 2,
                "date_update": "08.02.2023 10:33",
                "name": "SBER",
                "result": "-16.09",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "08.02.2023 10:34",
                "name": "SBER",
                "result": "-14.29",
                "currency": "rub"
            },
            {
                "type": 2,
                "date_update": "08.02.2023 10:36",
                "name": "SBER",
                "result": "1.12",
                "currency": "rub"
            },
            {
                "type": 1,
                "date_update": "08.02.2023 11:10",
                "name": "SBER",
                "result": "-6.28",
                "currency": "rub"
            }
        ]
    }
]

const TESTDATA_ORDERS = []

export {
  TESTDATA_HISTORY,
  TESTDATA_ORDERS
}